// extracted by mini-css-extract-plugin
export var background = "_64-0";
export var container = "_64-1";
export var contentItem = "_64-7";
export var extendedWarranty = "_64-5";
export var link = "_64-d";
export var modal = "_64-b";
export var modalCloseButton = "_64-9";
export var modalContent = "_64-3";
export var modalContentMain = "_64-6";
export var modalImageLogo = "_64-8";
export var modalLogo = "_64-a";
export var modalSideImage = "_64-4";
export var preview = "_64-c";
export var redoModal = "_64-2";